// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b070w{max-width:700px;margin-bottom:24px;align-items:flex-start;width:100%}.IWV9k{width:100%}.UHZqY{flex:0 0 220px;width:220px}.o4Oyr{flex:1;min-width:0;display:flex;align-items:stretch;justify-content:center}.njniS{display:inline-flex;margin-top:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `b070w`,
	"body": `IWV9k`,
	"leftColumn": `UHZqY`,
	"previewWrapper": `o4Oyr`,
	"saveButtonWrapper": `njniS`
};
export default ___CSS_LOADER_EXPORT___;
